import axios from "axios";
import { MS_GRAPH_URL } from "./endpoints/graph";

async function getUserPhoto({ request }) {
  return await axios(MS_GRAPH_URL.GetUserPhoto, {
    responseType: "arraybuffer",
    headers: {
      Authorization: `Bearer ${request.token}`,
    },
  }).catch((err) => {
    throw err;
  });
}

export { getUserPhoto };
